// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"6f9c46cf","605":"71b66680","809":"62452d41","981":"94dce167"}[chunkId] + ".chunk.js";
};